export const API_URL = import.meta.env.REACT_APP_API_URL;
export const ASSETS_URL = `${API_URL}/uploads/`;
export const REDIRECT_URL = "redirectUrl";
export const CSRF_HEADER = "X-CSRF-Token";
